"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrderStatusExternTranslationReducer = exports.OrderStatusInternTranslationReducer = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _nodeToolbox = require("@esnpm/node-toolbox");

var _translate = require("@esnpm/translate");

var _apiOrderStatusTranslation = require("../actions/esdb/apiOrderStatusTranslation");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OrderStatusInternTranslationReducer = exports.OrderStatusInternTranslationReducer = function OrderStatusInternTranslationReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        data: null,
        loading: false,
        error: null
    };
    var action = arguments[1];

    switch (action.type) {
        case _apiOrderStatusTranslation.API_ORDER_STATUS_TRANSLATION_SUCCESS:
            if (action.payload.data == null || action.payload.data == {}) {
                return state;
            }

            var fieldName = "INTERN_TRANSLATION";
            var returnDict = {};

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.entries(action.payload.data)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _step$value = _slicedToArray(_step.value, 2),
                        key = _step$value[0],
                        value = _step$value[1];

                    returnDict[key] = value[fieldName];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var newState = (0, _translate.registerTranslation)(state, "trOrderStatus", _defineProperty({}, fieldName, returnDict));

            return newState;
            break;

        default:
            return state;
    }
};

var OrderStatusExternTranslationReducer = exports.OrderStatusExternTranslationReducer = function OrderStatusExternTranslationReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        data: null,
        loading: false,

        error: null
    };
    var action = arguments[1];

    switch (action.type) {
        case _apiOrderStatusTranslation.API_ORDER_STATUS_TRANSLATION_SUCCESS:
            if (action.payload.data == null || action.payload.data == {}) {
                return state;
            }

            var fieldName = "EXTERN_TRANSLATION";
            var returnDict = {};

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.entries(action.payload.data)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _step2$value = _slicedToArray(_step2.value, 2),
                        key = _step2$value[0],
                        value = _step2$value[1];

                    returnDict[key] = value[fieldName];
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            var newState = (0, _translate.registerTranslation)(state, "trOrderStatus", _defineProperty({}, fieldName, returnDict));

            return newState;
            break;

        default:
            return state;
    }
};